import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { App } from './app/App'
import './vendor'
import { Provider } from 'jotai'

const root: HTMLElement | null = document.getElementById('root')

if (root) {
	ReactDOM.createRoot(root).render(
		// activate <React.StrictMode>...</React.StrictMode> if necessary (in optimize aims)
		<>
			<Provider>
				<App/>
			</Provider>
		</>
	)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
